/* Simulation - Prévision */
$('.action.prevision').click(function(e){
	setValues();
});

$('.single-property .amount-slider').mousemove(function() {
	setValues();
});

// $('#masthead .amount-slider').mousemove(function() {
// 	setValues();
// });



if ($('.box.filters').length){
	var detentionPeriod = $('.input-term:checked').val();
	$( document ).ready(function() {
		simulationFilters(detentionPeriod);
		$('.input-term:checked').addClass("selected");
	});
}

$('.term .input-term').click(function(e){
	var detentionPeriod = $(this).val();
	simulationFilters(detentionPeriod);
	$('.term .input-term').removeClass("selected");
	$(this).addClass("selected");

});

$('.parameters .return .radio input').click(function(e){
	var detentionPeriod = $('.term .input-term.selected').val();
	simulationFilters(detentionPeriod);

});

function simulationFilters(detentionPeriod){

	$('.original').trigger("click");

	var filters = $('.box.filters');

	var factor = detentionPeriod;
	$('.period-years').text(detentionPeriod);

	setTimeout(function(){
		var detentionPeriod = $('.term .input-term:checked').val();
		var originalRendementTotal = parseInt($('.rendement-total-value').text().replace(/[^0-9.]/g,""));
		var originalTotalRendement= parseInt($('.distributions-value').text().replace(/[^0-9.]/g,""));
		var originalSoldeProvision = parseInt($('.provisions-value').text().replace(/[^0-9.]/g,""));
		var originalRevenuTotal= parseInt($('.revenu-total').text().replace(/[^0-9.]/g,""));


		$(filters).find($('.original')).click(function(e){
			factor = 1;
		});

		$(filters).find($('.year')).click(function(e){
			factor = 1 / detentionPeriod;
		});

		$(filters).find($('.month')).click(function(e){
			factor = 1 / detentionPeriod / 12;
		});

		$(filters).find('span').click(function(e){
			$(this).addClass("active");
			$(this).siblings().removeClass("active");

			rendementTotal = originalRendementTotal * factor;
			totalRendement = originalTotalRendement * factor;
			soldeProvision = originalSoldeProvision * factor;
			revenuTotal = originalRevenuTotal * factor;

			$('.rendement-total-value').text(parseInt(rendementTotal).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
			$('.distributions-value').text(parseInt(totalRendement).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
			$('.provisions-value').text(parseInt(soldeProvision).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
			// $('.revenu-total').text(parseInt(revenuTotal).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

		});
	},
		500);


}


function setValues(){
 
	var factor;
	var years = parseInt($('.original').attr("data-year"));
	var activeFilter = $('.revenu-filters span.active').index();

	var montant = $('.amount-label').text();
		montant = montant.replace(/\D/g,'');

	var amountMax = parseInt($('.simulation').attr("data-max"));


	switch(activeFilter) {
	  case 0:
	    factor = 1;
	    break;
	  case 1:
	   factor = 1 / years;
	    break;
	   case 2:
	   factor = (1 / years) / 12;
	    break;
	  default:

	}

	var rendement = $('.modal-part').attr("data-equity");
	var duree = $('.modal-part').attr("data-period");
	var total = $('.modal-part').attr("data-required");

	var qpart = montant / total * 100;
		qpart = (Math.round(qpart*100)/100).toFixed(2);


	$('.total-returns-value').text(parseInt(factor * montant * rendement/100 * duree).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
	$('.rendement-distribution').text(parseInt(factor * montant * (rendement - 1)/100 * duree).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
	$('.fond-securite').text(parseInt((factor * montant * 1/100 * duree)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));
	$('.qpart').text(qpart);

	totalReturns = factor * montant * rendement/100 * duree;





	$('.total-returns').text("CHF " + totalReturns.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")+ ".-");

}

$('.modal-part .revenu-filters span').click(function(e){
	$(this).siblings().removeClass("active");
	$(this).addClass("active");
	setValues();
})



function simulation(){
	$('.simulation').each(function(){



		var simulation = $(this);
		var numbers = simulation.data('numbers');
		numbers.amount = numbers.amount_min;
		numbers.sliding = false;

		// Decrement
		$('.minus', simulation).on('click', function(){
			decrement(simulation, numbers);
		})

		// Increment
		$('.plus', simulation).on('click', function(){
			increment(simulation, numbers);
		})

		// Click on progress bar
		var slider = $('.amount-slider', simulation);
		// Sliding
		slider.on('mousedown', {slider: slider, simulation: simulation, numbers: numbers}, clickProgressBar);
		$(document).on('mouseup', function(){

			if (numbers.sliding){
				$(document).off('mousemove', clickProgressBar);
				slider.removeClass('sliding');
				numbers.sliding = false;
			}
		})

		calculateChartNumbers(numbers);
		setDetails(simulation, numbers);

		numbers.hasChart = $('#'+numbers.uniqid+'-chart').length;
		if (numbers.hasChart)
			initChart(simulation, numbers);

		// Change years
		$('.input-term', simulation).on('change', function(){
			numbers.current_term = numbers.terms[$(this).val()];
			setAmount(numbers.amount, simulation, numbers);

		})

		// Change scenario
		$('.input-scenario', simulation).on('change', function(){
			numbers.current_scenario = $(this).val();
			setAmount(numbers.amount, simulation, numbers);
		})

		// Show detail btn
		if ($('.show-details', simulation).length){
			$('.show-details', simulation).on('click', function(){
				$('.show-details', simulation).toggleClass('active');
				$('.details-content', simulation).stop().slideToggle(300);
			})
		}
	})
}

function increment(simulation, numbers){
	var amountTarget = numbers.amount + numbers.threshold;
	// Check that we're in the range
	if (amountTarget > numbers.amount_max)
		amountTarget = numbers.amount_max;

	setAmount(amountTarget, simulation, numbers);
}

function decrement(simulation, numbers){
	var amountTarget = numbers.amount - numbers.threshold;
	// Check that we're in the range
	if (amountTarget < numbers.amount_min)
		amountTarget = numbers.amount_min;

	setAmount(amountTarget, simulation, numbers);
}

function clickProgressBar(event){
	event.data.numbers.sliding = true;
	var slider = event.data.slider;
	var simulation = event.data.simulation;
	var sliderLeft = slider.offset().left;
	var sliderRight = sliderLeft + slider.width();
	var percentage = ((event.clientX - sliderLeft) * 100) / (sliderRight - sliderLeft);

	if (percentage > 100)
		percentage = 100;
	else if (percentage < 0)
		percentage = 0;

	setPercentage(percentage, simulation, event.data.numbers);

	// Set mousemove event listener
	if ('mousedown' == event.type){
		slider.addClass('sliding');
		$(document).on('mousemove', {slider: slider, simulation: simulation, numbers: event.data.numbers}, clickProgressBar);
	}

	return false;
}

function setAmount(amountTarget, simulation, numbers){
	numbers.amount = amountTarget;

	$('.amount-label', simulation).text(numbers.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	calculateChartNumbers(numbers);
	setProgressBar(simulation, numbers);
	setReturns(simulation, numbers);
	setDetails(simulation, numbers);
	if (numbers.hasChart){
		setChart(numbers);
	}
}

function setPercentage(percentage, simulation, numbers){
	var amountTarget = (percentage * (numbers.amount_max - numbers.amount_min) / 100) + numbers.amount_min;

	// Round target to threshold
	amountTarget = Math.round(amountTarget/numbers.threshold)*numbers.threshold;

	if (amountTarget < numbers.amount_min)
		amountTarget = numbers.amount_min;
	else if (amountTarget > numbers.amount_max)
		amountTarget = numbers.amount_max;

	setAmount(amountTarget, simulation, numbers);
}

function setProgressBar(simulation, numbers){
	var percentage = ((numbers.amount - numbers.amount_min) * 100) / (numbers.amount_max - numbers.amount_min);

	$('.amount-slider .progress-bar', simulation).css('width', percentage+'%');
	$('.amount-slider .handle', simulation).css('left', percentage+'%');
}

function setReturns(simulation, numbers){
	$('.total-returns-value', simulation).text(Math.round(numbers.totalSharing + numbers.totalGain).toLocaleString('fr-CH'));
	$('.annual-returns-value', simulation).text(numbers.current_term[numbers.current_scenario+'_return'].toFixed(2).toLocaleString('fr-CH'));
}

function setDetails(simulation, numbers){
	// $('.sell-shares-value', simulation).text(Math.round(numbers.totalSharing).toLocaleString('fr-CH'));
	// $('.distributions-value', simulation).text(Math.round(numbers.totalDistribution).toLocaleString('fr-CH'));
	// $('.provisions-value', simulation).text(Math.round(numbers.totalProvision).toLocaleString('fr-CH'));



	/* Extra */
	var annualReturn = numbers.current_term[numbers.current_scenario+'_return'];
	var length = numbers.provision.length;

	var winLost = 10 * (numbers.amount * (numbers.shares_variation[numbers.current_scenario]*1/100)) ;

	$('.win-lost-value', simulation).text(winLost.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var valeurVente = numbers.amount + winLost;
	$('.sell-shares-value').text(valeurVente.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var rendementTotal = numbers.amount * annualReturn/100 * length;
	$('.rendement-total-value').text(rendementTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var rendementDistribution = numbers.amount * (annualReturn - 1)/100 * length;
	$('.distributions-value').text(rendementDistribution.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var provision = numbers.amount * 1/100 * length;
	$('.provisions-value').text(provision.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var revenuTotal = rendementTotal + winLost;
	$('.revenu-total').text(revenuTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var totalReturns = numbers.amount + revenuTotal;
	$('.total-returns').text("CHF " + totalReturns.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")+ ".-");

	var revenuMensuelTotal = rendementTotal / length / 12 ;
	var revenuMensuelTotal = Math.round(revenuMensuelTotal, 2);
	$('.revenu-mensuel-total').text(revenuMensuelTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));

	var revenuMensuelTotalDistribue = Math.round((rendementDistribution / length / 12), 2);
	$('.revenu-mensuel-total-distribue').text(revenuMensuelTotalDistribue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"));


}

function calculateChartNumbers(numbers){



	if ($('.page-template-template-invest').length){
			var winLost = 10 * (numbers.amount * (numbers.shares_variation[numbers.current_scenario]*1/100)) ;


			var scenario =  numbers.current_scenario + "_return";
			var amount = numbers.amount;
			var years = numbers.current_term.years;
			var factor = numbers.current_term[scenario];

			$('.returns-value.total-returns').text("CHF " + parseInt(winLost + amount + amount * factor/100 * years).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")  + ".-");
	}

	numbers.sharing = []
	numbers.gain = []
	numbers.provision = []
	numbers.distribution = []
	numbers.xLabels = []
	for (var i = 1; i <= numbers.current_term.years; i++) {
		// Labels
		numbers.xLabels.push('Année ' + i);

		// Sharing values
		var shares_price = numbers.amount + numbers.amount * (numbers.shares_variation[numbers.current_scenario]*i/100);
		numbers.sharing.push(Math.round(shares_price));

		// Total gain
		var gain = shares_price * numbers.current_term[numbers.current_scenario+'_return'] * i / 100;
		numbers.gain.push(Math.round(gain));

		// Provision values
		var provision = (shares_price + gain) * 0.01;
		numbers.provision.push(Math.round(provision));

		// Distribution values
		var distribution = gain - provision;
		numbers.distribution.push(Math.round(distribution));

		if (i == numbers.current_term.years){
			numbers.totalSharing = shares_price;
			numbers.totalGain = gain;
			numbers.totalProvision = provision;
			numbers.totalDistribution = distribution;
		}
	}
}

function setChart(numbers){
	numbers.chart.data.labels = numbers.xLabels;
	numbers.chart.data.datasets[0].data = numbers.sharing;
	numbers.chart.data.datasets[1].data = numbers.distribution;
	numbers.chart.data.datasets[2].data = numbers.provision;
	numbers.chart.options.drawHorizontalLine.lineY = [numbers.amount, numbers.amount];
	numbers.chart.update();
}

function initChart(simulation, numbers){
	var barChartData = {
		labels: numbers.xLabels,
		datasets: [{
			label: 'Valeur des parts de copropriété',
			backgroundColor: window.chartColors.lightBlue,
			data: numbers.sharing,
			borderWidth: 0,
			radius: true,
		}, {
			label: 'Distributions',
			backgroundColor: window.chartColors.blue,
			data: numbers.distribution,
			borderWidth: 0,
			radius: false,
		}, {
			label: 'Provision',
			backgroundColor: window.chartColors.darkBlue,
			data: numbers.provision,
			borderWidth: 0,
			radius: false,
		}],
	};

	var ctx = document.getElementById(numbers.uniqid+'-chart').getContext('2d');

	numbers.chart = new Chart(ctx, {
		type: 'bar',
		data: barChartData,
		responsive: true,
		options: {
			layout: {
			padding: {
					left: -5,
					right: -100,
					top: 0,
					bottom: 0
				}
			},
			title: {
				display: false,
			},
			tooltips: {
				mode: 'index',
				intersect: false,
				callbacks: {
					label: function(tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || '';

						if (label) {
						label += ': ';
						}

						label += 'CHF '+tooltipItem.yLabel.toLocaleString('fr-CH') + '.-';
						return label;
					}
				}
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [{
					stacked: true,
					barPercentage: 1,
					categoryPercentage: 0.5,
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						fontFamily: "'Univers', Helvetica, Arial, sans-serif",
						fontSize: 15,
						color: window.chartColors.darkBlue,
						maxRotation: 0,
						padding: 10,
					}
				}],
				yAxes: [{
					stacked: true,
					gridLines: {
						color: '#eeeeee',
						zeroLineColor: '#fff',
						zeroLineWidth: 0,
						drawBorder: false,
					},
					ticks: {
						fontFamily: "'Univers', Helvetica, Arial, sans-serif",
						fontSize: 15,
						color: window.chartColors.darkBlue,
						padding: 15,
						maxRotation: 0,
						callback: function(value, index, values) {
	                        return value.toLocaleString('fr-CH') + '.-';
	                    }
					}
				}]
			},
			drawHorizontalLine: {
				lineY: [numbers.amount, numbers.amount],
				lineColor: window.chartColors.darkBlue,
			},
		}
	});
}

window.chartColors = {
	darkBlue: '#152333',
	blue: '#009de0',
	lightBlue: '#82ceed',
};

// Horizontal line
Chart.pluginService.register({
	afterDatasetDraw: function(chartInstance, easing) {
		var lineOpts = chartInstance.options.drawHorizontalLine;
		if (lineOpts) {

			var yAxis = chartInstance.scales["y-axis-0"];
			var yValueStart = yAxis.getPixelForValue(lineOpts.lineY[0], 0, 0, true);
			var yValueEnd = yAxis.getPixelForValue(lineOpts.lineY[1], 0, 0, true);

			var xAxis = chartInstance.scales["x-axis-0"];
			var xValueStart = xAxis.left;
			var xValueEnd = xAxis.right;

			var ctx = chartInstance.chart.ctx;
			ctx.save();

			// La ligne en pointillés
			ctx.setLineDash([8, 8]);
			ctx.strokeStyle = lineOpts.lineColor;
			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.moveTo(xValueStart, yValueStart);
			ctx.lineTo(xValueEnd, yValueEnd);
			ctx.stroke();

			ctx.restore();

			chartInstance.generateLegend('alut')
		}
	}
});

// Rounded bars
Chart.elements.Rectangle.prototype.draw = function() {
	var ctx = this._chart.ctx;
	var vm = this._view;
	var left, right, top, bottom, signX, signY, borderSkipped, radius;
	var borderWidth = vm.borderWidth;
	// Set Radius Here
	// If radius is large enough to cause drawing errors a max radius is imposed

	if (!vm.horizontal) {
		// bar
		left = vm.x - vm.width / 2;
		right = vm.x + vm.width / 2;
		top = vm.y;
		bottom = vm.base;
		signX = 1;
		signY = bottom > top? 1: -1;
		borderSkipped = vm.borderSkipped || 'bottom';
	} else {
		// horizontal bar
		left = vm.base;
		right = vm.x;
		top = vm.y - vm.height / 2;
		bottom = vm.y + vm.height / 2;
		signX = right > left? 1: -1;
		signY = 1;
		borderSkipped = vm.borderSkipped || 'left';
	}

	// Canvas doesn't allow us to stroke inside the width so we can
	// adjust the sizes to fit if we're setting a stroke on the line
	if (borderWidth) {
		// borderWidth shold be less than bar width and bar height.
		var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
		borderWidth = borderWidth > barSize? barSize: borderWidth;
		var halfStroke = borderWidth / 2;
		// Adjust borderWidth when bar top position is near vm.base(zero).
		var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
		var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
		var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
		var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
		// not become a vertical line?
		if (borderLeft !== borderRight) {
			top = borderTop;
			bottom = borderBottom;
		}
		// not become a horizontal line?
		if (borderTop !== borderBottom) {
			left = borderLeft;
			right = borderRight;
		}
	}

	ctx.beginPath();
	ctx.fillStyle = vm.backgroundColor;
	ctx.strokeStyle = vm.borderColor;
	ctx.lineWidth = borderWidth;

	// Corner points, from bottom-left to bottom-right clockwise
	// | 1 2 |
	// | 0 3 |
	var corners = [
		[left, bottom],
		[left, top],
		[right, top],
		[right, bottom]
	];

	// Find first (starting) corner with fallback to 'bottom'
	var borders = ['bottom', 'left', 'top', 'right'];
	var startCorner = borders.indexOf(borderSkipped, 0);
	if (startCorner === -1) {
		startCorner = 0;
	}

	function cornerAt(index) {
		return corners[(startCorner + index) % 4];
	}

	// Draw rectangle from 'startCorner'
	var corner = cornerAt(0);
	var nextCornerId;
	var nextCorner;
	var width;
	var height;
	var x;
	var y;

	ctx.moveTo(corner[0], corner[1]);

	for (var i = 1; i < 4; i++) {
		corner = cornerAt(i);
		nextCornerId = i+1;
		if(nextCornerId == 4){
			nextCornerId = 0
		}

		nextCorner = cornerAt(nextCornerId);

		width = corners[2][0] - corners[1][0];
		height = corners[0][1] - corners[1][1];
		x = corners[1][0];
		y = corners[1][1];

		var radius = width / 2;

		// Fix radius being too large
		if(radius > height/2){
			radius = height/2;
		}if(radius > width/2){
			radius = width/2;
		}

		// Draw radius
		ctx.moveTo(x + radius, y);
		ctx.lineTo(x + width, y);
		if (0 == this._datasetIndex){
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		}else{
			ctx.lineTo(x + width, y + height);
			ctx.lineTo(x, y + height);
		}
		ctx.lineTo(x, y);
	}

	ctx.fill();
	if (borderWidth) {
		ctx.stroke();
	}
};
